import { ActionBase } from '../../../core/store/action/ActionBase';

export const CHECK_GLOBAL_LOCK = '[Customer] Check Global Lock';

export class CheckGlobalLockAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CHECK_GLOBAL_LOCK;
}


// WEBPACK FOOTER //
// ./src/app/customer/store/actions/CheckGlobalLockAction.ts